/**
 * AppContextProvider
 *
 * defines providers to be merge into one
 * merges specified Providers into one Provider
 *
 * Allows you to use:
 *
 * <AppContextProvider>
 *      <SomeComponent> ... </SomeComponent>
 * </AppContextProvider>
 *
 * as opposed to:
 *
 * <AuthContextProvider>
 *      <TopicContextProvider>
 *          <CardContextProvider>
 *              <SomeComponent> ... </SomeComponent>
 *          </TopicContextProvider>
 *      </TopicContextProvider>
 * </AuthContextProvider>
 */
import { AuthProvider } from './auth';
import { CategoriesProvider } from './categories';
import { EnvProvider } from './env';
import { mergeProviders } from './mergeContextProviders';
import { MessagesProvider } from './messages';
import { ModeratorProvider } from './moderator';
import { OverviewProvider } from './overview';
import { ProfileProvider } from './profile';
import { SearchProvider } from './search';
import { TopicsProvider } from './topics';
import { UserProvider } from './user';
import { MessageBusProvider } from './messagebus';
import { EditPostProvider } from './edit';
import { ReplyProvider } from './reply';
const providers = [AuthProvider, CategoriesProvider, EnvProvider, MessagesProvider, ModeratorProvider, OverviewProvider, ProfileProvider, SearchProvider, TopicsProvider, UserProvider, MessageBusProvider, EditPostProvider, ReplyProvider];
export const AppContextProvider = mergeProviders(...providers);
//# sourceMappingURL=AppContextProvider.js.map